import { Injectable } from '@angular/core';
import { IConvertor } from '../../../../../models/project/project-model';
import {
    IEditBGMusic,
    IEditBGMusicInDTO,
    IEditBGMusicOutDTO,
} from '../../../../../models/project/edit/edit-background-music/edit-bg-music-model';

@Injectable({
    providedIn: 'root',
})
export class EditBGMusicConverterService implements IConvertor<IEditBGMusicInDTO, IEditBGMusic, IEditBGMusicOutDTO> {
    constructor() {}

    inToLocal(input: IEditBGMusicInDTO): IEditBGMusic {
        const localEditBGMusic: IEditBGMusic = {
            isOn: input.audioRelativeUrl ? input.isOn : false,
            audioRelativeUrl: input.audioRelativeUrl,
            toLoopIfFinished: input.toLoopIfFinished,
            volume: input.volume,
        };
        return localEditBGMusic;
    }
    localToOut(client: IEditBGMusic): IEditBGMusicOutDTO {
        const outEditBGMusic: IEditBGMusicOutDTO = {
            isOn: client.isOn,
            audioRelativeUrl: client.audioRelativeUrl,
            toLoopIfFinished: client.toLoopIfFinished,
            volume: client.volume,
        };
        return outEditBGMusic;
    }
}
